import React, { useState } from "react";
import Icon from "../Icon";
import { ExplanationLine, RowExplanation } from "../types";
import PaymentBreakdown from "./PaymentBreakdown";

export function firstDifference(a: string, b: string): number {
  if (a === b) return -1;
  const length = Math.min(a.length, b.length);
  for (let index = 0; index < length; index += 1) {
    if (a[index] !== b[index]) return index;
  }
  return length;
}

const Figure: React.FC<{ line: ExplanationLine }> = ({ line }) => {
  const at = line.compareTo ? firstDifference(line.value, line.compareTo) : -1;
  if (at < 0) return <>{line.value}</>;
  return (
    <>
      {line.value.slice(0, at)}
      <mark className="row-problem-diff">{line.value.slice(at)}</mark>
    </>
  );
};

const paymentCount = (count: number): string =>
  `${count} ${count === 1 ? "payment" : "payments"}`;

const RowProblemCard: React.FC<{ explanation: RowExplanation }> = ({
  explanation,
}) => {
  const [open, setOpen] = useState(false);
  const { classes, rowAmount, rowUnits } = explanation;
  const count = classes.reduce((total, group) => total + group.count, 0);

  return (
    <div className="row-problem">
      {explanation.headline && (
        <>
          <div className="row-problem-headline">
            <Icon name="alert-circle" size={13} strokeWidth={2.5} />
            {explanation.headline}
          </div>
          <dl className="row-problem-lines">
            {explanation.lines.map((line) => (
              <React.Fragment key={line.label}>
                <dt>{line.label}</dt>
                <dd className={line.highlight ? "mono is-highlight" : "mono"}>
                  <Figure line={line} />
                </dd>
              </React.Fragment>
            ))}
          </dl>
          {explanation.nextStep && (
            <div className="row-problem-next">{explanation.nextStep}</div>
          )}
        </>
      )}
      {count > 0 && (
        <button
          type="button"
          className={`row-problem-toggle ${open ? "is-open" : ""}`}
          onClick={() => setOpen((value) => !value)}
          aria-expanded={open}
        >
          <Icon name="chevron-down" size={14} strokeWidth={2.5} />
          {open ? "Hide the payments" : `Show the ${paymentCount(count)}`}
        </button>
      )}
      {open && (
        <PaymentBreakdown
          classes={classes}
          narration={explanation.narration}
          rowAmount={rowAmount}
          rowUnits={rowUnits}
        />
      )}
    </div>
  );
};

export default RowProblemCard;
